import { createEntityAdapter } from '@reduxjs/toolkit';
import { RoleResponsePrivate } from '@tests/types';

export const rolesAdapter = createEntityAdapter<RoleResponsePrivate<string>>();